<template>
  <div class="sidebar-logo-container"
       :class="{'collapse':false}">
    <transition name="sidebarLogoFade">
      <div v-if="collapse"
           key="collapse"
           class="sidebar-logo-link">
        <!-- <img v-if="logo"
             :src="logo"
             class="sidebar-logo">
        <h1 v-else
            class="sidebar-title">{{ title }} </h1> -->
      </div>
      <div v-else
           key="expand"
           class="sidebar-logo-link"
           to="/">
        <img v-if="logo"
             :src="logo"
             class="sidebar-logo">
        <h1 class="sidebar-title">{{ title }} </h1>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'logo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: '前端知识汇总',
      logo: require('@/assets/images/logo.png')
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2db7f5;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 41px;
      height: 41px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
